import { render, staticRenderFns } from "./TagBreadcrumbs.vue?vue&type=template&id=e3beae06"
import script from "./TagBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./TagBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./TagBreadcrumbs.vue?vue&type=style&index=0&id=e3beae06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports